import { useState } from "react";
import { updateState } from "@/lib/utils";
export default function useFormState(currentStepIndex, activeForm, formSubmission) {
    const [storedValues, setStoredValues] = useState(updateState(formSubmission));
    const [submission, setSubmission] = useState(formSubmission);
    function updateFields(result, stringResult) {
        setStoredValues((old) => {
            const newValues = { ...old };
            newValues[result.name] = stringResult;
            return newValues;
        });
        setSubmission((old) => {
            let newSubmissions = { ...old };
            if (!newSubmissions)
                throw Error("Submission is null");
            if (!old) {
                newSubmissions = {
                    form_id: activeForm.id,
                    index: currentStepIndex,
                    product_slug: activeForm.product?.slug || "",
                    child_index: activeForm.product?.child_index,
                    values: {
                        [result.name]: result,
                    },
                };
            }
            else {
                newSubmissions.values = {
                    ...newSubmissions.values,
                    [result.name]: result,
                };
            }
            console.log("submission ", newSubmissions);
            return newSubmissions;
        });
    }
    return { storedValues, submission, updateFields };
}
//# sourceMappingURL=useFormState.js.map